var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,38.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.04888871,0,0,0.04696054,-0.18968209,13.933744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 279.066,150.285 262.363,133.992 206.578,78.5938 157.473,30.3672 108.367,78.5938 107.699,79.2461 87.9883,98.4727 35.543,149.633 c -27.39066,26.722 -27.39066,70.062 0,96.785 13.0273,12.711 30.3984,19.551 49.4414,19.551 18.0386,0 36.0786,-7.168 49.4376,-19.551 l 23.051,-22.484 23.05,22.484 c 13.028,12.711 30.731,19.879 49.438,19.879 18.707,0 36.414,-7.168 49.441,-19.879 13.028,-12.707 20.043,-29.652 20.043,-48.23 0,-18.247 -7.351,-35.192 -20.379,-47.903 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 22.5,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart15X);
export default __webpack_public_path__ + "static/media/Heart@1_5x.7c7ab902d2ad9dda1482ce38191dc80c.svg";
export { ForwardRef as ReactComponent };